import React from "react";
import Layout from "../Components/CotizarService/Layout";

const CotizarService = () => {
  return <Layout />;
};

export default CotizarService;
